import React from 'react'
import Card from '../../commons/Card'

class ResidentialHistory extends React.Component {
  render() {
    const { histories, history } = this.props

    return (
      <div>
        <div className='big d-sm-flex justify-content-between'>
          <div className='block'>
            {history.address}
            <br/>
          </div>
          <div className='align-self-center mt-2 mt-sm-0'>
            {history.years} years, {history.months} months
          </div>
        </div>
        { histories.length > 1 &&
          <hr/>
        }
      </div>
    )
  }
}

export default ResidentialHistory
